import React, { Component } from 'react';
import '../trident-campaigns/metrics/MetricsStatsTable.scss';
import _ from 'lodash';
import './Panel.scss';
import { Button, Col, Row, Tooltip } from 'grab-ui';
import MetricsDownloadCsv from '../../../img/ucd_project_metrics_download_csv.svg';
import scribe from '@grab-x/scribe-web-sdk';
import ScribeEventName, { ScribeExtras } from 'omega-rtc/constants/scribe';
import { Dropdown } from 'semantic-grab-ui';


class Panel extends Component {
  downloadNotSentReport = (campaignId, reportUrl) => {
    scribe.sendEvent(ScribeEventName.CAMPAIGN_METRICS, {
      campaignId,
      ...ScribeExtras.DOWNLOAD_REPORT,
    });
    window.location.href = reportUrl;
  }


  render() {
    const { title, reports, campaignID } = this.props;
    const showDownloadButton = _.isBoolean(this.props.showDownloadButton) ? this.props.showDownloadButton : true;

    return (
      <div className={'omega-rtc-panel'}>
        <div className={'omega-rtc-panel-header'}>
          <Row style={{ padding: 0 }}>
            <Col span={6}>
              <h3 className={'title'}>{title}</h3>
            </Col>
            {showDownloadButton &&
              <Col className="project-page-metrics-download-icon" span={6} offset={12}>
                {!_.isEmpty(reports) ?
                  <React.Fragment><Dropdown icon="" placement={'botomLeft'} className={'download-dropdown'}>
                    <Dropdown.Menu>
                      {
                        _.map(reports, (report) => {
                          return (<Dropdown.Item
                            onClick={() => this.downloadNotSentReport(campaignID, report.url)}
                          > {report.name} report</Dropdown.Item>);
                        })
                      }
                    </Dropdown.Menu>
                  </Dropdown>
                  <Button className="downloadBtn" type="link">
                    {' '}
                    <img alt="icon" src={MetricsDownloadCsv} />
                  </Button>
                  </React.Fragment>
                  :
                  <Tooltip title="Reports are not available" placement="bottom">
                    <Button className="downloadBtn" type="link" disabled>{' '}
                      <img alt="icon" src={MetricsDownloadCsv} style={{ opacity: 0.5 }} />
                    </Button>
                  </Tooltip>
                }
              </Col>
            }
          </Row>
        </div>
        <div>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Panel;
